import { HttpClient, httpResource } from '@angular/common/http';
import { Injectable, computed, inject } from '@angular/core';

import { Observable } from 'rxjs';
import * as z from 'zod';

import { Resource } from '../schemas';
import { storedResource } from '../shared';
import { Lambda } from './lambda';
import { Messenger } from './messenger';

@Injectable({ providedIn: 'root' })
export class ResourcesService {
  private http = inject(HttpClient);

  private url = inject(Lambda).getResourcesUrl();

  private readonly CACHE_KEY = `lcm:service-cache:resource`;

  private resourcesResource = httpResource<Resource[]>(() => this.url, {
    defaultValue: JSON.parse(window.localStorage.getItem(this.CACHE_KEY) || '[]'),
    parse: z.array(Resource).parse,
  });

  constructor() {
    storedResource(this.resourcesResource, this.CACHE_KEY, inject(Messenger));
  }

  resources = computed(() => this.resourcesResource.value());
  pending = this.resourcesResource.isLoading;

  reload() {
    this.resourcesResource.reload();
  }

  delete(id: string): Observable<unknown> {
    const request = this.http.delete(this.url + '/' + id);
    return request;
  }

  save(instance: Resource, forEdit = false): Observable<Resource> {
    let request: Observable<Resource>;
    if (forEdit) {
      request = this.http.put<Resource>(this.url + '/' + instance.Id, instance);
    } else {
      request = this.http.post<Resource>(this.url, instance);
    }

    return request;
  }
}
